import React, { SelectHTMLAttributes, useEffect, useRef } from "react";

import { useField } from "@unform/core";

import {
  ArrowDown,
  Container,
  Label,
  Option,
  Required,
  SelectContainer,
  Select as SelectStyled,
} from "./styles";

interface IOptions {
  label: string;
  value: string | number;
}

interface ISelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  label?: string;
  options: IOptions[];
}

export default function Select({
  name,
  label,
  options,
  required,
  className,
  defaultValue: defaultValueOfSelect,
  ...rest
}: ISelectProps) {
  const selectRef = useRef<HTMLSelectElement>(null);

  const { fieldName, defaultValue, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef,
      getValue: (ref: any) => {
        if (rest.multiple) {
          if (!ref.current.value) {
            return [];
          }
          return ref.current.value.map((option: ISelectProps) => option.value);
        }
        if (!ref.current.value) {
          return "";
        }
        return ref.current.value;
      },
    });
  }, [fieldName, registerField, rest.multiple]);

  return (
    <Container className={className}>
      {!!label && (
        <Label htmlFor={name}>
          {label}
          {required && <Required>*</Required>}
        </Label>
      )}

      <SelectContainer>
        <SelectStyled
          id={name}
          name={name}
          ref={selectRef}
          defaultValue={defaultValueOfSelect || defaultValue}
          {...rest}
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </SelectStyled>

        <ArrowDown />
      </SelectContainer>
    </Container>
  );
}
